import React, { useEffect, useMemo, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import configData from "../../config/config.json";
import {
  ShowError, confirmationDialog, DROPDOWN_LIST_NONE,
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, JSON_KEY_DESCRIPTION,
  JSON_KEY_STATUS, ITEM_STATUS, ITEM_CREATE, ITEM_MODIFY,  
  JSON_KEY_SUBMITTER, SUSPENDED, JSON_KEY_INSTRUMENT,
  JSON_KEY_PRIORITY, JSON_KEY_TRADING_RULES,
  JSON_KEY_EXCHANGE, JSON_KEY_MARKET, JSON_KEY_TIME, JSON_KEY_DATE,
  JSON_KEY_ID, JSON_KEY_RUN_IMMEDIATELY, NO,
  ITEM_RUN, ITEM_SET_TIME,
  EVENT_TYPE_TRADING_EVENT_STATUS,
  EVENT_TYPE_TRADING_EVENT_RUN,
  EVENT_TYPE_TRADING_EVENT_CREATE,
  EVENT_TYPE_TRADING_EVENT_MODIFY,
  StatusSimpleOptions,
  JSON_KEY_CODE,
  EVENT_TYPE_SET_TIME,
  ConvertStatusFromNameToId,
  SUSPEND,
  TRIGGERED,
  STATUS_SUSPEND,
  ITEM_MOVE_ALL,
  JSON_KEY_MINUTES,
  JSON_KEY_HOURS,
  MOVE_TYPE_ACTIVE,
  MOVE_TYPE_SUSPEND,
  JSON_KEY_MOVE_TYPE,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSG_TYPE_TRADING_EVENTS_MOVE_ALL, MSGTYPE_SET_NEW_TIME, MSGTYPE_TRADING_EVENT_CREATE, MSGTYPE_TRADING_EVENT_MODIFY, MSGTYPE_TRADING_EVENT_RUN, MSGTYPE_TRADING_EVENT_STATUS, } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";
import { ConvertFromTradingEventStatusId, yesNoOptions } from "../../common/convert_functions";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";

const TradingEventsAdminForm = ({ rowData, onClose, tradingEventOptions, instrumentOptions, marketOptions, exchangeOptions, tradingRulesOptions }) => {

   const typeOptions = useMemo(() => ([
      { id: MOVE_TYPE_ACTIVE, name: "Move only active trading events" },
      { id: MOVE_TYPE_SUSPEND, name: "Move suspended trading events to activate" },
   ]), []);

   const userId = useSelector(selectTSUserId);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab 1
   const [tradingEvent, setTradingEvent] = useState(rowData?.id);

   let initialStatus = rowData?.status ? ConvertStatusFromNameToId(rowData.status) : SUSPEND;

   // override triggered → suspend
   if (rowData?.status === TRIGGERED) {
      initialStatus = STATUS_SUSPEND;  
   }

   const [status, setStatus] = useState(initialStatus);
   const [moveType, setMoveType] = useState(MOVE_TYPE_ACTIVE);

   // tab 2 & 3
   const [priority, setPriority] = useState(rowData?.priority);
   const [code, setCode] = useState(rowData?.code);
   const [description, setDescription] = useState(rowData?.descr);
   const [exchange, setExchange] = useState(DROPDOWN_LIST_NONE);
   const [market, setMarket] = useState(DROPDOWN_LIST_NONE);
   const [instrument, setInstrument] = useState(DROPDOWN_LIST_NONE);
   const [tradingRules, setTradingRules] = useState(DROPDOWN_LIST_NONE);
   const [time, setTime] = useState(rowData?.time);
   const [date, setDate] = useState(rowData?.date);
   const [runImmediately, setRunImmediately] = useState(NO);

   // tab 5
   const [hours, setHours] = useState(0);
   const [minutes, setMinutes] = useState(0);

   // const onTradingEventDropDownChange = (e) => setCode(e.target.value);
   const onTradingEventDropDownChange = (e) => setTradingEvent(Number(e.target.value));
   const onExchangesDropDownChange = (e) => setExchange(e.target.value);
   const onMarketsDropDownChange = (e) => setMarket(e.target.value);
   const onInstrumentsDropDownChange = (e) => setInstrument(e.target.value);
   const onTradingRulesDropDownChange = (e) => setTradingRules(e.target.value);
   const onStatusDropDownChange = (e) => {setStatus(e.target.value)};
   const onMoveTypeDropDownChange = (e) => {setMoveType(e.target.value)};
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   const onRunImmediatelyDropDownChange = (e) => {
      setRunImmediately(e.target.value);
      if (e.target.value === NO) {
         setDisabledFields({
            date: false,
            time: false,
         });
      } else {
         setDisabledFields({
            date: true,
            time: true,
         });
      }
      setDate(null);
      setTime(null);
   };

   // Disabled fields state
   const [disabledFields, setDisabledFields] = useState({});

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onTradingEventModifyDropDownChange = (e) => {
      setTradingEvent(e.target.value);
      setCode('');
      setDescription('');
      setExchange(DROPDOWN_LIST_NONE);
      setMarket(DROPDOWN_LIST_NONE);
      setInstrument(DROPDOWN_LIST_NONE);
      setTradingRules(DROPDOWN_LIST_NONE);
      setPriority('');
      setTime('');
      setDate('');
      setStatus(SUSPENDED);
   };

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) {
         handleStatusConfirmationSubmit(item);
         onClose(); 
      }
   };
   
   useEffect(() => {
      if (rowData?.id) { setTradingEvent(rowData.id); }
      if (rowData?.code) { setCode(rowData.code); }
      if (rowData?.exch) { setExchange(rowData.exch); }
      if (rowData?.market) { setMarket(rowData.market); }
      if (rowData?.instr) { setInstrument(rowData.instr); }
      if (rowData?.rules) { setTradingRules(rowData.rules); }
      if (rowData?.priority) { setPriority(rowData.priority); }
      if (rowData?.time) { setTime(rowData.time); }
      if (rowData?.date) { setDate(rowData.date); }
   }, [rowData]);
   
   const handleStatusConfirmationSubmit = (submitItem) => {
      const basePayload = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_ID]: tradingEvent,
      };

      const dispatch = (type, payload) =>
         DispatchTransactionEvent(EVENT_TOPIC_FOR_TRANSACTION_SERVER, type, payload);

      // console.log('TradingEventsAdminForm: status: ', status);

      switch (submitItem) {
         case ITEM_STATUS: {
               dispatch(EVENT_TYPE_TRADING_EVENT_STATUS, {
               ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TRADING_EVENT_STATUS,
               [JSON_KEY_STATUS]: status,
            });
            break;
         }

         case ITEM_RUN: {
               dispatch(EVENT_TYPE_TRADING_EVENT_RUN, {
               ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TRADING_EVENT_RUN,
            });
            break;
         }

         case ITEM_SET_TIME: {
            const formatted_time = time ? moment(time, "HH:mm:ss", true).isValid() ? moment(time, "HH:mm:ss").format("HHmmss") : "" : "";;
            // console.log('set time, time: ', time, ', format time: ', formatted_time);

            const payload = {
               [JSON_KEY_SUBMITTER]: userId,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_SET_NEW_TIME,
               [JSON_KEY_TIME]: Number(formatted_time),
            };

            if (date && moment.isMoment(date)) {
               payload[JSON_KEY_DATE] = Number(date.format("YYYYMMDD"));
            }

            dispatch(EVENT_TYPE_SET_TIME, payload);
            break;
         }

         
         case ITEM_MOVE_ALL: {

            const payload = {
               [JSON_KEY_SUBMITTER]: userId,
               [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_TRADING_EVENTS_MOVE_ALL,
               [JSON_KEY_HOURS]: Number(hours),
               [JSON_KEY_MINUTES]: Number(minutes),
               [JSON_KEY_MOVE_TYPE]: moveType,
            };

            dispatch(MSG_TYPE_TRADING_EVENTS_MOVE_ALL, payload);
            break;
         }


         case ITEM_CREATE: {
            // console.log('item create, trd code: ', tradingRules);
            const formatted_time = time ? moment(time, "HH:mm:ss", true).isValid() ? moment(time, "HH:mm:ss").format("HHmmss") : "" : "";;
            const payload = {
               ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TRADING_EVENT_CREATE,
               [JSON_KEY_CODE]: code,
               [JSON_KEY_TRADING_RULES]: tradingRules,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_PRIORITY]: Number(priority),
               [JSON_KEY_TIME]: Number(formatted_time),
               [JSON_KEY_RUN_IMMEDIATELY]: runImmediately,
               [JSON_KEY_STATUS]: status,
            };

            // Conditionally add optional fields
            if (date && moment.isMoment(date)) {
               payload[JSON_KEY_DATE] = Number(date.format("YYYYMMDD"));
            }

            if (exchange && exchange !== "None") {
               payload[JSON_KEY_EXCHANGE] = exchange;
            }

            if (market && market !== "None") {
               payload[JSON_KEY_MARKET] = market;
            }

            if (instrument && instrument !== "None") {
               payload[JSON_KEY_INSTRUMENT] = instrument;
            }

            dispatch(EVENT_TYPE_TRADING_EVENT_CREATE, payload);
            break;
         }

         case ITEM_MODIFY: {
            const formatted_time = time ? moment(time, "HH:mm:ss", true).isValid() ? moment(time, "HH:mm:ss").format("HHmmss") : "" : "";;
            const payload = {
               ...basePayload,
               [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_TRADING_EVENT_MODIFY,
               [JSON_KEY_TRADING_RULES]: tradingRules,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_PRIORITY]: Number(priority),
               [JSON_KEY_TIME]: Number(formatted_time),
               // [JSON_KEY_STATUS]: status,
            };

            // Conditionally add optional fields
            if (date && moment.isMoment(date)) {
               payload[JSON_KEY_DATE] = Number(date.format("YYYYMMDD"));
            }

            if (exchange && exchange !== "None") {
               payload[JSON_KEY_EXCHANGE] = exchange;
            }

            if (market && market !== "None") {
               payload[JSON_KEY_MARKET] = market;
            }

            if (instrument && instrument !== "None") {
               payload[JSON_KEY_INSTRUMENT] = instrument;
            }

            dispatch(EVENT_TYPE_TRADING_EVENT_MODIFY, payload);
            break;
         }

         default:
            console.warn('TradingEventsAdminForm: unknown submit item', submitItem);
      }
   };

   const handleStatusSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);
      ConfirmAndSubmit({
         title: "Trading Event Status Change",
         text: `Setting trading event ${tradingEvent} to ${ConvertFromTradingEventStatusId(status)}`,
         item: ITEM_STATUS,
      });
   };

   const handleRunImmediatelySubmit = () => {
      if (!tradingEvent) return ShowError("Trading Event Id is missing");
      if (runImmediately === NO) return ShowError("Choose Yes to run immediately");

      ConfirmAndSubmit({
         title: `Trading Event ${tradingEvent}, to run immediately`,
         text: `Setting trading event ${tradingEvent} to run immediately`,
         item: ITEM_RUN,
      });
   };

   const handleSetTimeSubmit = () => {
      ConfirmAndSubmit({
         title: `Set New Time`,
         text: `Setting time to ${time}`,
         item: ITEM_SET_TIME,
      });
   };

   const handleMoveAllSubmit = () => {
      let text; 
      if (moveType === MOVE_TYPE_ACTIVE) {
         text = 'Active';
      }
      else {
         text = 'Suspended';
      }

      ConfirmAndSubmit({
         title: `Moving ${text}) Trading Events`,
         text: `Moving hours: ${hours}, minutes: ${minutes}`,
         item: ITEM_MOVE_ALL,
      });
   };

   const ValidateFields = () => {
      if (!tradingEvent) {return "Trading Event Id is missing";}
      if (!priority) {return "Priority is missing";}
      if (!description || typeof description !== "string" || description.trim() === "") return "Description is missing";      
      if (!tradingRules) return "Trading Rules is missing";
      // if (!time) return "Time is missing: ";
      if (!status) return "status is missing";
      return null;
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Create Trading Event",
         text: `Creating new trading event: ${tradingEvent}`,
         item: ITEM_CREATE,
      });
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();

      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Modify Trading Event",
         text: `Modifying trading event: ${tradingEvent}`,
         item: ITEM_MODIFY,
      });
   };

   useEffect(() => {
      if (selectedTabIndex === 1) {
         setRunImmediately(NO);
      }
   }, [selectedTabIndex]);
   
   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Trading Event Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>Run</Tab>
               <Tab>Modify</Tab>
               <Tab>Create</Tab>
               <Tab>Move</Tab>
               {configData.DEBUG && <Tab>Set Time (Debug Only)</Tab>}
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
                  <div className="top">
                     {RenderDropdown("Trading Event Id", tradingEvent, tradingEventOptions, onTradingEventDropDownChange)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
                  </div>

                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
                  </div>
               </form>
            </TabPanel>

            {/* Tab 2: Run trading event */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleRunImmediatelySubmit)}>
                  <div className="top">
                     {RenderDropdown("Trading Event Id", tradingEvent, tradingEventOptions, onTradingEventDropDownChange, true)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Trading Rules", tradingRules, tradingRulesOptions, onTradingRulesDropDownChange, true)}
                  </div>
                  <div>
                     <InputField label="Description" value={description} onChange={setDescription} readOnly={true} />
                  </div>
                  <div className="top">
                     {RenderDropdown("Exchange", exchange, exchangeOptions, onExchangesDropDownChange, true)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Market", market, marketOptions, onMarketsDropDownChange, true)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Instrument", instrument, instrumentOptions, onInstrumentsDropDownChange, true)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Run Immediately", runImmediately, yesNoOptions, onRunImmediatelyDropDownChange)}
                  </div>
                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
                  </div>
               </form>
            </TabPanel>

            {/* Tab 3: Modify Trading Event */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
                  <div className="top">
                     {RenderDropdown("Trading Event Id", tradingEvent, tradingEventOptions, onTradingEventModifyDropDownChange)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Trading Rules", tradingRules, tradingRulesOptions, onTradingRulesDropDownChange)}
                  </div>
                  <div>
                     <InputField label="Description" value={description} onChange={setDescription} />
                  </div>
                  <div className="top">
                     {RenderDropdown("Exchange", exchange, exchangeOptions, onExchangesDropDownChange)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Market", market, marketOptions, onMarketsDropDownChange)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Instrument", instrument, instrumentOptions, onInstrumentsDropDownChange)}
                  </div>
                  <div className="top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                     <label style={{ fontSize: '1rem', color: '#5791B9', width: '100px' }}>Date</label>
                     <Datetime
                        className="dark-datetime-input"  
                        value={date}
                        onChange={setDate}
                        dateFormat="YYYY:MM:DD"
                        timeFormat={false}
                        inputProps={{ placeholder: "Optional Date" }}
                     />
                  </div>
                  <div className="top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                     <label style={{ fontSize: '1rem', color: '#5791B9', width: '100px' }}>Time</label>
                     <Datetime
                        className="dark-datetime-input"  
                        value={time}
                        onChange={setTime}
                        dateFormat={false}
                        timeFormat="HH:mm:ss"
                        inputProps={{ placeholder: "Pick a time" }}
                     />
                  </div>
                  <div>
                     <InputField label="Priority" value={priority} onChange={setPriority} type="number" />
                  </div>
                  {/*}
                  <div className="top">
                     {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
                  </div> */}

                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
                  </div>
               </form>
            </TabPanel>            
            
            {/* Tab 4: Create Trading Event */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
                  <div className="top">
                     {RenderDropdown("Trading Rules", tradingRules, tradingRulesOptions, onTradingRulesDropDownChange)}
                  </div>
                  <div>
                     <InputField label="Code" value={code} onChange={setCode} />
                  </div>
                  <div >
                     <InputField label="Description" value={description} onChange={setDescription} />
                  </div>
                  <div className="top">
                     {RenderDropdown("Exchange", exchange, exchangeOptions, onExchangesDropDownChange)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Market", market, marketOptions, onMarketsDropDownChange)}
                  </div>
                  <div className="top">
                     {RenderDropdown("Instrument", instrument, instrumentOptions, onInstrumentsDropDownChange)}
                  </div>
                  <div className="top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                     <label style={{ fontSize: '1rem', color: '#5791B9', width: '100px' }}>Date</label>
                     <Datetime
                        value={date}
                        onChange={setDate}
                        dateFormat="YYYY:MM:DD"
                        timeFormat={false}
                        inputProps={{ placeholder: "Optional Date", disabled: disabledFields.date }}
                     />
                  </div>
                  <div className="top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                     <label style={{ fontSize: '1rem', color: '#5791B9', width: '100px' }}>Time</label>
                     <Datetime
                        value={time}
                        onChange={setTime}
                        dateFormat={false}
                        timeFormat="HH:mm:ss"
                        inputProps={{ placeholder: "Pick a time", disabled: disabledFields.time }}
                     />
                  </div>
                  <div>
                     <InputField label="Priority" value={priority} onChange={setPriority} type="number" />
                  </div>
                  {/*
                  <div className="top">
                     {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
                  </div>
                  */}
                  <div className="top">
                     {RenderDropdown("Run Immediately", runImmediately, yesNoOptions, onRunImmediatelyDropDownChange)}
                  </div>
                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
                  </div>
               </form>
            </TabPanel>

            {/* Tab 5: Move active and suspended trading events */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleMoveAllSubmit)}>
                  <div>
                     <InputField label="Hours" value={hours} onChange={setHours} type="number" />
                  </div>
                  
                  <div>
                     <InputField label="Minutes" value={minutes} onChange={setMinutes} type="number" />
                  </div>
                  
                  <div className="top">
                     {RenderDropdown("Movement Type", moveType, typeOptions, onMoveTypeDropDownChange)}
                  </div>
                  
                  <div className="buttons">
                     <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                        Cancel
                     </Button>
                     <Button className="right-button" variant="success" size="lg" type="submit">
                        Submit
                     </Button>
                  </div>
               </form>
            </TabPanel>

            {/* Tab 6: Set new time */}
            {configData.DEBUG && (
               <TabPanel>
                  <form onSubmit={handleSubmit(handleSetTimeSubmit)}>
                     <div className="top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ fontSize: '1rem', color: '#5791B9', width: '100px' }}>Date</label>
                        <Datetime
                           value={date}
                           onChange={setDate}
                           dateFormat="YYYY:MM:DD"
                           timeFormat={false}
                           inputProps={{ placeholder: "Optional Date", disabled: disabledFields.date }}
                        />
                     </div>
                     <div className="top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ fontSize: '1rem', color: '#5791B9', width: '100px' }}>Time</label>
                        <Datetime
                           value={time}
                           onChange={setTime}
                           dateFormat={false}
                           timeFormat="HH:mm:ss"
                           inputProps={{ placeholder: "Pick a time", disabled: disabledFields.time }}
                        />
                     </div>
                     <div className="buttons">
                        <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                           Cancel
                        </Button>
                        <Button className="right-button" variant="success" size="lg" type="submit">
                           Submit
                        </Button>
                     </div>
                  </form>
               </TabPanel>
            )}

         </Tabs>
         </div>
      </div>
   );
};

export default TradingEventsAdminForm;
